// src/components/Settings/SettingsGridLayout.jsx

import React, { useState, useContext, useEffect } from "react";
import { useParams, useNavigate }                 from "react-router-dom";
import "./SettingsGridLayout.css";
import { ThemeContext }      from "../../../../context/ThemeContext";
import { logout }            from "../../../Pages/PublicLayout/SigninPage/auth";
import { fetchUserSettings } from "./Utils/fetchUserSettings";

// ✅ Import extracted components
import SelfDetail       from "./Layout/SelfDetail";
import ProfileSettings  from "./Layout/ProfileSettings";
import ParentalControl  from "./Layout/ParentalControl";
import GetSubscription  from "./Layout/GetSubscription";
import SecuritySettings from "./Layout/SecuritySettings";
import PrivacySettings  from "./Layout/PrivacySettings";
import RewardCenter     from "./Layout/RewardCenter";
import DeleteAccount    from "./Layout/DeleteAccount";

// ─────────────────────────────────────────────────────────────────────────────
// TAB DEFINITIONS
// ─────────────────────────────────────────────────────────────────────────────

const TABS = [
  { key: "self",     label: "👤 Self Details"       },
  { key: "profile",  label: "🎨 Profile Settings"   },
  { key: "sub",      label: "💳 Subscription"       },
  { key: "parental", label: "👨‍👩‍👧 Parental Control" },
  { key: "security", label: "🔐 Security"           },
  { key: "privacy",  label: "🔒 Privacy"            },
  { key: "reward",   label: "🎁 Reward Center"      },
];

// ─────────────────────────────────────────────────────────────────────────────
// SETTINGS ROOT
// ─────────────────────────────────────────────────────────────────────────────

const Settings = () => {
  const { theme }                 = useContext(ThemeContext);
  const [userData, setUserData]   = useState(null);
  const [activeTab, setActiveTab] = useState("self");
  const navigate                  = useNavigate();
  const { userid }                = useParams();

  useEffect(() => {
    import(`./Styles/themes/${theme}/themes.css`)
      .then(() => console.log(`Loaded ${theme} theme`))
      .catch(() => console.warn(`Theme CSS not found for: ${theme}`));
  }, [theme]);

  useEffect(() => {
    const load = async () => {
      try {
        const data = await fetchUserSettings(userid);
        if (data) setUserData(data);
      } catch (err) { console.error("Failed to load user settings:", err); }
    };
    load();
  }, [userid]);

  const handleLogout = () => {
    localStorage.removeItem("session");
    localStorage.removeItem("userLoggedin");
    alert("You have been logged out.");
    logout();
    navigate("/");
  };

  const renderPanel = () => {
    switch (activeTab) {
      case "self":     return <SelfDetail userid={userid} />;
      case "profile":  return <ProfileSettings userid={userid} />;
      case "sub":      return <GetSubscription />;
      case "parental": return <ParentalControl />;
      case "security": return <SecuritySettings />;
      case "privacy":  return <PrivacySettings />;
      case "reward":   return <RewardCenter />;
      case "delete":   return <DeleteAccount />;
      default:         return <SelfDetail userid={userid} />;
    }
  };

  return (
    <div className="st-page-wrapper">
      <div className="st-tab-bar-wrapper">
        <div className="st-tab-bar">

          {/* ── Left-aligned main tabs ───────────────────────────── */}
          <div className="st-tab-bar-left">
            {TABS.map(tab => (
              <button
                key={tab.key}
                className={`st-tab-btn ${activeTab === tab.key ? "st-tab-btn--active" : ""}`}
                onClick={() => setActiveTab(tab.key)}
                title={tab.label}
                style={{color: "white"}}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* ── Right-aligned actions ────────────────────────────── */}
          <div className="st-tab-bar-right">
            <button
              className={`st-tab-btn st-tab-btn--delete ${activeTab === "delete" ? "st-tab-btn--active-delete" : ""}`}
              onClick={() => setActiveTab("delete")}
              title="Delete your account permanently"
            >
              🗑️ Delete Account
            </button>
          </div>

        </div>
      </div>

      <div className="st-settings-container">
        <div className="st-settings-content">
          {renderPanel()}
        </div>
      </div>
    </div>
  );
};

export default Settings;
